import BranchEnum from '@/modules/core/models/BranchEnum'
import { useLoadingStore } from '@/modules/core/stores'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { raterGuard } from './guards'
import SpanishBranches from '@/modules/core/models/SpanishBranches'

export const HOME_RATER_ROUTES = [
  {
    path: SpanishBranches.home,
    name: 'rater-hogar',
    component: () => import('@/modules/common/rater/views/UrlRedirectView.vue'),
    meta: {
      branchName: BranchEnum.HOME
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing-almost-got-it')
      raterGuard(to, from, next)
    }
  }
]
